<template lang="pug">
div
    loading-overlay(:is-loading="is_loading")
    form(@submit.prevent="handleSubmit")
        .form-inputs
            .form-group
                label 名前
                span.badge.badge-primary.ml-2 *必須
                input.form-control(
                    v-model="formData.name",
                    placeholder="例: 申込完了"
                    :class="validationClass('name')")
                template(v-if="$v.formData.name.$dirty")
                    .invalid-feedback(v-if="!$v.formData.name.required") 名前を入力してください

        .form-inputs
            .form-group
                label コンバージョン計測方法
                span.badge.badge-primary.ml-2 *必須
                div.form-check(v-for="method in methods" :key="method.value")
                    input.form-check-input(
                        type="radio"
                        :value="method.value"
                        v-model="formData.method"
                        :id="'method_' + method.value"
                        autocomplete="off"
                    )
                    label.form-check-label(:for="'method_' + method.value") {{ method.label }}
                    span.upper-master-label.ml-2(v-if="method.value === CV_METHOD.LINKE_TO_EXTERNAL_SERVICE") Master以上

                template(v-if="$v.formData.method.$dirty")
                    .invalid-feedback(v-if="!$v.formData.method.required") コンバージョン計測方法を入力してください

        //- ページビュー選択時
        .form-inputs(v-if="isPageViewSelected")
            .form-group
                label コンバージョンページの指定
                span.badge.badge-primary.ml-2 *必須
                div.d-flex.align-items-center.mb-2
                    div.d-flex.w-75
                        input.form-control.mr-2(type="text" v-model="formData.url" placeholder="https://sitelead.net（URLを入力してください）")
                        select.form-control.custom-select.mr-2(v-model="formData.condition")
                            option(
                                v-for="condition in urlConditions"
                                :key="condition.value"
                                :value="condition.value") {{ condition.label }}
                .mt-2
                    label.d-block.mb-1 パラメータ条件
                    small.form-text.text-muted.d-block.mb-2(v-if="query_param_conditions.length > 0") パラメータ名（左辺）は完全一致、パラメータ値（右辺）は前方一致で表示の判別をします。パラメータ値が未入力の場合、パラメータ名の一致有無で判定します。
                    div(v-for="(queryCondition, index) in query_param_conditions" :key="'cv-query-condition-' + index" class="align-items-center mb-2")
                        .d-flex.w-75.align-items-center
                            input.form-control.mr-2(style="max-width: 28%;" type="text" v-model="queryCondition.query_key" placeholder="パラメータ名（例：utm_source）")
                            span.align-self-center.text-muted.font-weight-bold(style="flex-shrink: 0; padding: 0 0.75rem; margin-right: 5px;") =
                            input.form-control.mr-2(style="max-width: 28%;" type="text" v-model="queryCondition.query_value" placeholder="パラメータ値（例：google）")
                            select.form-control.custom-select.mr-2(style="max-width: 20%;" v-model.number="queryCondition.exclude")
                                option(:value="0") 前方一致で表示
                                option(:value="1") 前方一致で除外
                            button.btn.btn-danger(style="max-width: 10%;" type="button" @click="removeQueryParamCondition(index)") 削除
                        .invalid-feedback.d-block(v-if="queryCondition.error") {{ queryCondition.error }}
                    button.btn.btn-primary.mt-2(type="button" @click="addQueryParamCondition") パラメータを追加
                template(v-if="$v.formData.query_param.$dirty")
                    .invalid-feedback.d-block(v-if="!$v.formData.query_param.noQuestionMark") ?を除いたクエリ文字列を入力してください
                template(v-if="existsUrlError")
                    .invalid-feedback 選択されているWebサイトと一致しません。管理画面上部の「Webサイト」箇所をご確認ください。
                template(v-if="pageViewConditionError")
                    .invalid-feedback {{ pageViewConditionError }}

        p(style="color: green;" v-if="validUrl === true && formData.method === 'page_view'") タグの設置が確認できました。コンバージョン計測が可能です。
        p(style="color: red; white-space: pre-line;" v-if="validUrl === false")
            | タグの設置が確認できませんでした。コンバージョン計測ができません。
            | コンバージョンページにタグが設置されているか確認してください。
            | タグ設置方法は
            a(href="/users/tag_domains") こちら

        .form-inputs(v-if="isExternalserviceSelected")
            .form-group
                label コンバージョン連携対象
                span.badge.badge-primary.ml-2 *必須
                .div.form-check(v-for="group in externalServiceGroups" :key="group.value")
                    input.form-check-input(
                        type="radio"
                        :value="group.value"
                        v-model="externalServiceGroup"
                        :id="'externalServiceGroup_' + group.value"
                        @change="handleExternalServiceGroupChange"
                    )
                    label.form-check-label(:for="'externalServiceGroup_' + group.value") {{ group.label }}
                    help-tooltip(v-if="group.value === EXTERNAL_SERVICE_GROUP.LINE" html-key='cvLine')
                    help-tooltip(v-if="group.value === EXTERNAL_SERVICE_GROUP.ACCESS_TRADE" html-key='cvAccessTrade')

        //- 外部CV連携選択時
        .form-inputs(v-if="isExternalServiceGroupSelected")
            .form-group
                label コンバージョン連携詳細
                span.badge.badge-primary.ml-2 *必須
                .div.form-check(v-for="detail in filterServiceDetails" :key="detail.value")
                    input.form-check-input(
                        type="radio"
                        :value="detail.value"
                        v-model="formData.external_service_type"
                        :id="'select_' + detail.value")
                    label.form-check-label(:for="'select_' + detail.value") {{ detail.label }}
                    help-tooltip(v-if="detail.value === EXTERNAL_SERVICE_TYPE.LSTEP" html-key='cvLstep')

        .form-inputs(v-if="isExternalServiceGroupSelected && access_trade_advertiser_cv_flag && isAccessTradeExternalServiceType(formData.external_service_type)")
            .form-group
                label アクセストレードプログラム情報
                span.badge.badge-primary.ml-2 *必須
                .form-group.d-flex.align-items-center.mb-1
                    p.m-0.pr-3(style="width: 150px") マーチャント名
                    input.form-control.w-50(
                        type="text"
                        id="merchant_name"
                        v-model="formData.merchant_name"
                        :class="validationClass('merchant_name')"
                    )
                template(v-if="$v.formData.merchant_name.$dirty")
                    .invalid-feedback(v-if="!$v.formData.merchant_name.maxLength") 255文字以内にしてください。
                    .invalid-feedback(v-if="!$v.formData.merchant_name.required") 必須入力です。

                .form-group.d-flex.align-items-center.mb-0
                    p.m-0.pr-3(style="width: 150px") 成果対象ID
                    input.form-control.w-50(
                        type="text"
                        id="target_result_id"
                        v-model="formData.target_result_id"
                        :class="validationClass('target_result_id')"
                    )
                template(v-if="$v.formData.target_result_id.$dirty")
                    .invalid-feedback(v-if="!$v.formData.target_result_id.maxLength") 255文字以内にしてください。
                    .invalid-feedback(v-if="!$v.formData.target_result_id.required") 必須入力です。

        .form-inputs(v-if="isExternalServiceGroupSelected && isLineExternalServiceType(formData.external_service_type)")
            .form-group
                label LINE友達追加計測方法
                span.badge.badge-primary.ml-2 *必須
                .div.form-check(v-for="lineMeasurment in currentMeasuments" :key="lineMeasurment.value")
                    input.form-check-input.mb-1(
                        type="radio"
                        :value="lineMeasurment.value"
                        v-model="formData.cv_method"
                        :id="'select_' + lineMeasurment.value"
                        @change="updateLineMethodParam")
                    label.form-check-label(:for="'select_' + lineMeasurment.value") {{ lineMeasurment.label }}
                    help-tooltip(v-if="lineMeasurment.value === LINE_MEASURMENT.MESSAGING_API" html-key='cvMessagingApi')
                    help-tooltip(v-if="lineMeasurment.value === LINE_MEASURMENT.LOGIN" html-key='cvLineLogin')
                    .input-group.mt-2.w-50(v-if="lineMeasurment.value === LINE_MEASURMENT.MESSAGING_API")
                        input.form-control.w-50#webhook-setting-url(
                            type="text"
                            value="https://client.sitelead.net/api/v1/cv_tags/webhook/cv/track"
                            readonly=true)
                        div.input-group-append
                            button.btn.btn-outline-secondary(type="button" @click="copyToClipboard") コピー
                    p.form-text.text-muted.mb-1(v-if="lineMeasurment.value === LINE_MEASURMENT.MESSAGING_API && isLstepExternalServiceType(formData.external_service_type)") LステップのWebhookの入力欄に上記のURLを設定してください。
                    p.form-text.text-muted(v-else-if="lineMeasurment.value === LINE_MEASURMENT.MESSAGING_API && isLineExternalServiceType(formData.external_service_type)") LINEのWebhookの入力欄に上記のURLを設定してください。
                    p.form-text.text-muted(v-else-if="lineMeasurment.value === LINE_MEASURMENT.MESSAGING_API") LINEまたはLステップのWebhookの入力欄に上記のURLを設定してください。
                    .mb-2(v-if="lineMeasurment.value === LINE_MEASURMENT.MESSAGING_API && isLstepExternalServiceType(formData.external_service_type)")
                        label.form-check-label Lステップ連携用流入経路分析URL
                        input.form-control.w-50(
                            v-model="formData.lstep_tracking_url",
                            placeholder="例：https://liff.line.me/○○"
                            :class="validationClass('lstep_tracking_url')")
                        template(v-if="$v.formData.lstep_tracking_url.$dirty")
                            .invalid-feedback(v-if="!$v.formData.lstep_tracking_url.maxLength") 255文字以内にしてください。
                            .invalid-feedback(v-if="!$v.formData.lstep_tracking_url.isLiffUrl") http://liff.line.me または https://liff.line.me から始まるURLを入力してください。
                    
        .form-inputs(v-if="isExternalServiceGroupSelected && isLineExternalServiceType(formData.external_service_type)")
            .form-group
                div
                    label LINEアカウント一覧
                    span.badge.badge-primary.mx-2 *必須
                    button.btn.btn-sm.btn-outline-secondary.ml-2(type="button", @click="fetchLatestLineAccounts") 最新データ取得
                template(v-if="lineAccountsWithMessagingApi && formData.cv_method == LINE_MEASURMENT.MESSAGING_API")
                    .div.form-check(v-for="(account, index) in lineAccountsWithMessagingApi" :key="index")
                        input.form-check-input(type="radio" 
                            :value="account" 
                            :id="'select_accounts_' + index" 
                            v-model="line"
                        )
                        label.form-check-label.mr-3(:for="'select_accounts_' + index") 名前: {{ account.name }}
                        label.form-check-label.mr-3(:for="'select_accounts_' + index") LINEアカウントID: {{ account.uid }}
                        a(:href="'/users/line_accounts/' + account.id + '/edit'")
                            img(src="/images/edit_icon.png" style="width: 16px; margin-bottom: 4px;")
                template(v-if="lineAccountsWithMessagingApi == 0 && formData.cv_method === LINE_MEASURMENT.MESSAGING_API")
                    p.mb-0
                        | Messaging API方式のLINEアカウントが登録されていません。

                template(v-if="lineAccountsWithLogin && formData.cv_method == LINE_MEASURMENT.LOGIN")
                    .div.form-check(v-for="(account, index) in lineAccountsWithLogin" :key="index")
                        input.form-check-input(type="radio" 
                            :value="account" 
                            :id="'select_accounts_' + index" 
                            v-model="line"
                        )
                        label.form-check-label.mr-3(:for="'select_accounts_' + index") 名前: {{ account.name }}
                        label.form-check-label.mr-3(:for="'select_accounts_' + index") LINEアカウントID: {{ account.uid }}
                        a.mr-3(:href="'/users/line_accounts/' + account.id + '/edit'")
                            img(src="/images/edit_icon.png" style="width: 16px; margin-bottom: 4px;")
                        a.mr-3(@click.prevent="deleteLineAccount(account.id)")
                            img(src="/images/trash.png" style="width: 16px; margin-bottom: 4px;")

                template(v-if="lineAccountsWithLogin == 0 && formData.cv_method == LINE_MEASURMENT.LOGIN")
                    p.mb-0
                        | LINE ログイン方式のLINEアカウントが登録されていません。

                template(v-if="$v.line.id.$dirty && !$v.line.id.required")
                    .invalid-feedback LINEアカウントを選択してください

                button.mt-2.btn.btn-primary(type="button", @click="openLineAccountForm") LINEアカウント新規登録
    
        //- 送信ボタン
        .form-actions
            button.btn.btn-default(type="submit") {{ cv_tag && cv_tag.id > 0 ? '更新する' : '登録する' }}
            help-tooltip(html-key='cvSlid' variant="warning")

    upgrade-upper-master(
        v-if="showUpgradeModal"
        @close-modal="handleUpgradeModalClose"
    )

</template>

<script>
import axios from '../plugins/axios'
import { required, maxLength } from "vuelidate/lib/validators";
import UpgradeUpperMaster from "./modals/upgrade_upper_master.vue";
import LoadingOverlay from "./parts/loading_overlay.vue";
import {
    parseKeyValueFromQueryString,
    buildQueryStringFromKeyValue,
} from '../utils/queryParamKeyValue';

// コンバージョン計測方法
const CV_METHOD = {
    PAGE_VIEW: 'page_view',
    LINKE_TO_EXTERNAL_SERVICE: 'link_to_external_service',
}

// コンバージョン連携対象
const EXTERNAL_SERVICE_GROUP = {
    LINE: 'line',
    ACCESS_TRADE: 'access_trade',
    NORMAL: 'normal'
}

// コンバージョン連携詳細
const EXTERNAL_SERVICE_TYPE = {
    ACCESS_TRADE: 'access_trade',
    LINE_LINK_TO_ACCESS_TRADE: 'line_link_to_access_trade',
    LSTEP_LINK_TO_ACCESS_TRADE: 'lstep_link_to_access_trade',
    LINE: 'line',
    LSTEP: 'lstep',
    NORMAL: 'normal'
}

// LINE友達追加計測地点
const LINE_MEASURMENT = {
    MESSAGING_API: 'messaging_api',
    LOGIN: 'login',
}

export default {
    props: {
        cv_tag: Object,
        site_page: Object,
        site_page_queries: {
            type: Array,
            default() {
                return [];
            },
        },
        tag_domain: Object,
        full_url: String,
        line_account: Object,
        line_accounts_with_messaging_api: Array,
        line_accounts_with_login: Array,
        is_test_user: {
            type: Boolean,
            default: false
        },
        access_trade_advertiser_cv_flag: {
            type: Boolean,
            default: false
        },
        upper_master: Boolean
    },
    data() {
        return {
            // 定数読込
            CV_METHOD,
            EXTERNAL_SERVICE_GROUP,
            EXTERNAL_SERVICE_TYPE,
            LINE_MEASURMENT,
            is_loading: false,
            formData: {
                id: this.cv_tag?.id || '',
                name: this.cv_tag?.name || '',
                method: this.cv_tag?.method || '',
                external_service_type: this.cv_tag?.external_service_type || EXTERNAL_SERVICE_TYPE.NORMAL,
                url: this.full_url || '',
                condition: this.site_page?.condition || 'equals',
                site_page_id: this.site_page?.id || 0,
                cv_method: this.line_account?.cv_method || '',
                line_account_id: this.line_account?.id || null,
                merchant_name: this.cv_tag?.merchant_name || '',
                target_result_id: this.cv_tag?.target_result_id || '',
                lstep_tracking_url: this.cv_tag?.lstep_tracking_url || '',
                query_param: '',
            },
            // コンバージョン計測方法　選択肢のオブジェクト配列
            methods: [
                { value: CV_METHOD.PAGE_VIEW, label: 'ページビュー' },
                { value: CV_METHOD.LINKE_TO_EXTERNAL_SERVICE, label: '外部コンバージョン連携' },
                // ['クリック（Webページ内のボタンをクリックされた場合計測する）', 'click']
            ],
            // コンバージョンページの指定 URL条件のオブジェクト配列
            urlConditions: [
                { value: 'equals', label: '等しい' },
                { value: 'contains', label: '含む' },
                { value: 'startsWith', label: '先頭が一致' },
                { value: 'endsWith', label: '最後が一致' },
                { value: 'notEquals', label: '等しくない' },
                { value: 'notContains', label: '含まない' },
                // { value: 'notStartsWith', label: '先頭が一致しない #12月25日(水)除外'},
                // { value: 'notEndsWith', label: '最後が一致しない'}
            ],
            // コンバージョン連携対象 選択項目のオブジェクト配列
            externalServiceGroups: [
                { value: EXTERNAL_SERVICE_GROUP.LINE, label: 'LINE'},
                { value: EXTERNAL_SERVICE_GROUP.ACCESS_TRADE, label: 'アフィリエイト'}
            ],
            // コンバージョン連携詳細 アフィリエイト選択時の選択項目のオブジェクト配列
            atServiceDetails: [
                { value: EXTERNAL_SERVICE_TYPE.ACCESS_TRADE, label: '広告主CV計測（アクセストレードアフィリエイター用）', onlyTestUser: false},
                { value: EXTERNAL_SERVICE_TYPE.LINE_LINK_TO_ACCESS_TRADE, label: 'LINE公式アカウント連携友達追加計測（アクセストレード広告主用）', onlyTestUser: false, requiresAccessTradeAdvertiserFlag: true},
                { value: EXTERNAL_SERVICE_TYPE.LSTEP_LINK_TO_ACCESS_TRADE, label: 'Lステップ連携友達追加計測（アクセストレード広告主用）', onlyTestUser: false, requiresAccessTradeAdvertiserFlag: true}
            ],
            // コンバージョン連携詳細　LINE選択時の選択項目のオブジェクト配列
            lineServiceDetails: [
                { value: EXTERNAL_SERVICE_TYPE.LINE, label: 'LINE公式アカウント計測（LINE向けMAツールを利用しない）', onlyTestUser: false},
                { value: EXTERNAL_SERVICE_TYPE.LSTEP, label: 'Lステップ連携計測', onlyTestUser: false}
            ],
            // LINE友達追加計測方法 LINE計測を選択時の選択項目のオブジェクト配列
            lineMeasurments: [
                { value: LINE_MEASURMENT.MESSAGING_API, label: '友達追加地点計測（Messaging API方式 Webhook利用）', onlyTestUser: false},
                { value: LINE_MEASURMENT.LOGIN, label: 'LINEログイン地点計測（LINEログイン方式）', onlyTestUser: false}
            ],
            // LINE友達追加計測方法 Lステップ計測を選択時の選択項目のオブジェクト配列
            lstepMeasurments: [
                { value: LINE_MEASURMENT.MESSAGING_API, label: '友達追加地点計測（Messaging API方式 LステップWebhook転送機能利用）', onlyTestUser: false},
                { value: LINE_MEASURMENT.LOGIN, label: 'LINEログイン地点計測（LINEログイン方式）', onlyTestUser: false}
            ],
            line: {
                id: this.line_account?.id,
                name: this.line_account?.name,
                uid: this.line_account?.uid,
                cv_method: this.line_account?.cv_method,
            },
            validUrl: null,
            existsUrlError: false,
            pageViewConditionError: '',
            externalServiceGroup: '',
            lineAccountsWithMessagingApi: [...this.line_accounts_with_messaging_api],
            lineAccountsWithLogin: [...this.line_accounts_with_login],
            query_param_conditions: [],
        };
    },
    components: {
        UpgradeUpperMaster,
        LoadingOverlay
    },
    validations() {
        return {
            formData: {
                name: { required },
                method: { required },
                external_service_type: { required },
                // マーチャント名のバリデータ
                merchant_name: {
                    maxLength: maxLength(255),
                    required: function (value) {
                        const isAT = this.isAccessTradeExternalServiceType(this.formData.external_service_type);
                        if (!isAT) {
                            return true;
                        }
                        return required(value);
                    }
                },
                // 成果対象IDのバリデータ
                target_result_id: {
                    maxLength: maxLength(255),
                    required: function (value) {
                        const isAT = this.isAccessTradeExternalServiceType(this.formData.external_service_type);
                        if (!isAT) {
                            return true;
                        }
                        return required(value);
                    }
                },
                // Lステップ流入経路分析URLのバリデータ
                lstep_tracking_url: {
                    maxLength: maxLength(255),
                    isLiffUrl: function (value) {
                        if (!value || value.trim() === '') {
                            return true;
                        }
                        try {
                            const url = new URL(value);

                            if (!['http:', 'https:'].includes(url.protocol)) {
                                return false;
                            }
                            if (url.hostname !== 'liff.line.me') {
                                return false;
                            }
                            if (!url.pathname || url.pathname === '/') {
                                return false;
                            }

                            return true;
                        } catch (e) {
                            return false;
                        }
                    },
                },
                query_param: {
                    noQuestionMark: function (value) {
                        if (!value || value.trim() === '') {
                            return true;
                        }
                        return !value.includes('?');
                    }
                }
            },
            line : {
                id: {
                    required: function() {
                        const isLineService = this.isLineExternalServiceType(this.formData.external_service_type);
                        if (!isLineService) {
                            return true;
                        }
                        // 成果計測地点設定値とLINEアカウントの設定情報が一致しているか確認
                        if (required(this.line) && this.formData.cv_method != this.line.cv_method) {
                            return false;
                        }
                        return required(this.line);
                    }
                }
            }
        }
    },
    mounted() {
        this.line = this.line_account;
        this.initializeQueryParamConditionsFromProps();
        this.initializeExternalServiceGroup();
    },
    methods: {
        // バリデーション結果のクラス名分岐の判定
        validationClass(field) {
            const fieldPath = field.includes('.') ? field : `formData.${field}`;
            const validator = fieldPath.split('.').reduce((obj, key) => obj?.[key], this.$v);

            if (!validator || !validator.$dirty) {
                return '';
            }

            return {
                'is-invalid': validator.$invalid,
                'is-valid': !validator.$invalid
            };
        },
        initializeExternalServiceGroup() {
            if (this.cv_tag?.method === CV_METHOD.LINKE_TO_EXTERNAL_SERVICE) {
                if (this.isAccessTradeGroup(this.cv_tag?.external_service_type)) {
                    this.externalServiceGroup = EXTERNAL_SERVICE_GROUP.ACCESS_TRADE;
                } else if (this.isLineGroup(this.cv_tag?.external_service_type)) {
                    this.externalServiceGroup = EXTERNAL_SERVICE_GROUP.LINE;
                }
            } else if (this.isExternalserviceSelected) {
                if (this.isAccessTradeGroup(this.cv_tag?.external_service_type)) {
                    this.externalServiceGroup = EXTERNAL_SERVICE_GROUP.ACCESS_TRADE;
                } else if (this.isLineGroup(this.cv_tag?.external_service_type)) {
                    this.externalServiceGroup = EXTERNAL_SERVICE_GROUP.LINE;
                }
            }
        },
        isAccessTradeGroup(externalServiceType) {
            return [
                EXTERNAL_SERVICE_TYPE.ACCESS_TRADE
                ,EXTERNAL_SERVICE_TYPE.LINE_LINK_TO_ACCESS_TRADE
                ,EXTERNAL_SERVICE_TYPE.LSTEP_LINK_TO_ACCESS_TRADE
            ].includes(externalServiceType);
        },
        isLineGroup(externalServiceType) {
            return [
                EXTERNAL_SERVICE_TYPE.LINE
                ,EXTERNAL_SERVICE_TYPE.LSTEP
            ].includes(externalServiceType);
        },
        isAccessTradeExternalServiceType(externalSErviceType) {
            return [
                EXTERNAL_SERVICE_TYPE.LINE_LINK_TO_ACCESS_TRADE
                ,EXTERNAL_SERVICE_TYPE.LSTEP_LINK_TO_ACCESS_TRADE
            ].includes(externalSErviceType);
        },
        isLineExternalServiceType(externalServiceType) {
            return [
                EXTERNAL_SERVICE_TYPE.LINE
                ,EXTERNAL_SERVICE_TYPE.LINE_LINK_TO_ACCESS_TRADE
                ,EXTERNAL_SERVICE_TYPE.LSTEP
                ,EXTERNAL_SERVICE_TYPE.LSTEP_LINK_TO_ACCESS_TRADE
            ].includes(externalServiceType);
        },
        isLstepExternalServiceType(externalServiceType) {
            return [
                EXTERNAL_SERVICE_TYPE.LSTEP
                ,EXTERNAL_SERVICE_TYPE.LSTEP_LINK_TO_ACCESS_TRADE
            ].includes(externalServiceType);
        },
        initializeQueryParamConditionsFromProps() {
            if (this.site_page_queries?.length > 0) {
                this.query_param_conditions = [];
                this.site_page_queries.forEach((q) => {
                    const parsed = parseKeyValueFromQueryString(q.query || '');
                    this.query_param_conditions.push({
                        query_key: parsed.key,
                        query_value: parsed.value,
                        query: q.query || '',
                        condition: 'startsWith',
                        exclude: Number(q.exclude) ? 1 : 0,
                    });
                });
                return;
            }
            this.query_param_conditions = [];
        },
        syncQueryParamConditionQueryFields() {
            this.query_param_conditions.forEach((row, index) => {
                const q = buildQueryStringFromKeyValue(row.query_key, row.query_value);
                this.$set(this.query_param_conditions[index], 'query', q);
            });
        },
        joinedQueryParamFromConditions() {
            return this.query_param_conditions
                .map((row) => (row.query || '').trim())
                .filter((q) => q.length > 0)
                .join('&');
        },
        validateCvQueryConditions() {
            let isValid = true;

            this.query_param_conditions.forEach((queryCondition, index) => {
                this.$set(this.query_param_conditions[index], 'error', null);

                const keyTrim = (queryCondition.query_key || '').trim();
                const valueTrim = (queryCondition.query_value || '').trim();
                const built = buildQueryStringFromKeyValue(queryCondition.query_key, queryCondition.query_value);

                if (!built) return;

                if (!keyTrim && valueTrim) {
                    this.$set(this.query_param_conditions[index], 'error', 'パラメータ名を入力してください。');
                    isValid = false;
                    return;
                }

                if (built.includes('?')) {
                    this.$set(this.query_param_conditions[index], 'error', '?を除いたクエリ文字列を入力してください。');
                    isValid = false;
                }
            });

            return isValid;
        },
        addQueryParamCondition() {
            this.query_param_conditions.push({
                query_key: '',
                query_value: '',
                query: '',
                condition: 'startsWith',
                exclude: 0,
            });
        },
        removeQueryParamCondition(index) {
            this.query_param_conditions.splice(index, 1);
        },
        buildQueryParamConditionsPayload() {
            return this.query_param_conditions
                .map((row) => ({
                    query: row.query,
                    condition: 'startsWith',
                    exclude: Number(row.exclude),
                }))
                .filter((row) => row.query && row.query.trim());
        },
        handleExternalServiceGroupChange() {
            if (this.externalServiceGroup === EXTERNAL_SERVICE_GROUP.ACCESS_TRADE) {
                this.formData.external_service_type = EXTERNAL_SERVICE_TYPE.ACCESS_TRADE;
            } else if (this.externalServiceGroup === EXTERNAL_SERVICE_GROUP.LINE) {
                this.formData.external_service_type = EXTERNAL_SERVICE_TYPE.LINE;
            } else {
                this.formData.external_service_type = EXTERNAL_SERVICE_TYPE.NORMAL;
            }
            this.formData.cv_method = '';
            this.line = null;
        },
        async handleSubmit() {
            this.pageViewConditionError = '';

            if (this.isPageViewSelected) {
                this.syncQueryParamConditionQueryFields();
                this.formData.query_param = this.joinedQueryParamFromConditions();
                if (!this.validateCvQueryConditions()) {
                    return;
                }
            }

            if(this.formData.method === CV_METHOD.LINKE_TO_EXTERNAL_SERVICE) {
                this.formData.url = `${this.tag_domain.domain}/`;
                this.formData.condition = 'contains';
            }

            this.formData.line_account_id = null;
            if (this.isExternalserviceSelected && this.isLineExternalServiceType(this.formData.external_service_type)) {
                if (this.line && this.line.id) {
                    this.formData.line_account_id = this.line.id;
                }
            }

            await this.checkUrl();

            if (this.existsUrlError) {
                return;
            }

            this.$v.$touch();
            if (this.$v.formData.$invalid) {
                console.error("Validation failed");
                return;
            }

            if (this.isPageViewSelected && !this.formData.url?.trim() && !this.formData.query_param?.trim()) {
                this.pageViewConditionError = 'URLまたはパラメータ条件を入力してください。';
                return;
            }

            try {
                this.is_loading = true;

                const url = this.cv_tag?.id > 0 ? `/api/v1/cv_tags/update` : '/api/v1/cv_tags/new';
                const payload = { ...this.formData };
                if (this.isPageViewSelected) {
                    payload.query_param_conditions = this.buildQueryParamConditionsPayload();
                }
                const response = await axios.post(url, payload);

                this.is_loading = false;

                if (!response.data.is_error) {
                    if (this.isLineExternalServiceType(this.formData.external_service_type)) {
                        window.location.href = `/users/cv_tags?luid=${this.line.uid}&liffId=${this.line.liff_id}`;
                    } else {
                        window.location.href = "/users/cv_tags";
                    }
                } else {
                    console.error("Error: Something went wrong while saving data");
                }
            } catch (error) {
                console.error("Error occurred:", error);
                if (error.response) {
                    console.error("Error response:", error.response);
                }
                this.is_loading = false;
            }
        },
        async checkUrl() {
            this.validUrl = null;
            this.existsUrlError = false;

            if (this.formData.method !== 'page_view') {
                return;
            }

            if (!this.formData.url || !this.formData.url.trim()) {
                if (this.formData.query_param && this.formData.query_param.trim()) {
                    return;
                }
                return;
            }

            try {
                const userSelectedDomain = this.tag_domain?.domain ? new URL(this.tag_domain.domain.trim()).hostname : null;
                const inputDomain = new URL(this.formData.url.trim()).hostname;

                if (userSelectedDomain && inputDomain !== userSelectedDomain) {
                    this.existsUrlError = true;
                    return;
                }
            } catch (error) {
                this.existsUrlError = true;
                return;
            }
        },
        async fetchLatestLineAccounts() {
            try {
                const response = await axios.post('/api/v1/line_accounts/fetch', {
                    cv_method: this.formData.cv_method
                });

                const targetMap = {
                    messaging_api: 'lineAccountsWithMessagingApi',
                    login: 'lineAccountsWithLogin'
                };

                const targetKey = targetMap[this.formData.cv_method];

                this[targetKey] = response.data;

                if (!targetKey) throw new Error('invalid cv_method');

                this.$toasted.success("最新データを取得しました。");
            } catch (error) {
                this.$toasted.error("最新データ取得に失敗しました");
            }
        },
        updateLineMethodParam() {
            if (this.isLineExternalServiceType(this.formData.external_service_type)) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('line_method', this.formData.cv_method);
            window.history.replaceState({}, '', currentUrl.toString());
            }
        },
        openLineAccountForm() {
            this.lineAccountWindow = window.open(this.lineAccountUrl, '_blank');
        },
        async deleteLineAccount(accountId) {
            if (!confirm('本当に削除しますか？')) return;
            try {
                const response = await axios.delete(`/users/line_accounts/${accountId}`, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    params: {
                        redirect_path: window.location.pathname + window.location.search
                    }
                });

                if (response.data.success) {
                    this.removeLineAccountFromList(accountId);
                    this.$toasted.success("削除しました");
                } else {
                    this.$toasted.error(response.data.message || '削除に失敗しました');
                }
            } catch (error) {
                console.error('Delete error:', error);
                if (error.response && error.response.data && error.response.data.message) {
                    this.$toasted.error(error.response.data.message);
                } else {
                    this.$toasted.error('削除に失敗しました');
                }
            }
        },
        removeLineAccountFromList(accountId) {
            this.lineAccountsWithMessagingApi = this.lineAccountsWithMessagingApi.filter(
                account => account.id !== accountId
            );
            this.lineAccountsWithLogin = this.lineAccountsWithLogin.filter(
                account => account.id !== accountId
            );
            if (this.line && this.line.id === accountId) {
                this.line = null;
            }
        },
        handleUpgradeModalClose() {
            this.showUpgradeModal = false;
            this.$nextTick(() => {
                const methodRadios = document.querySelectorAll('input[type="radio"][id^="method_"]');
                methodRadios.forEach(radio => {
                    radio.checked = false;
                });
                const serviceGroupRadios = document.querySelectorAll('input[type="radio"][id^="externalServiceGroup_"]');
                serviceGroupRadios.forEach(radio => {
                    radio.checked = false;
                });
            });
        },
        async copyToClipboard() {
            const url = document.getElementById('webhook-setting-url').value;
            try {
                await navigator.clipboard.writeText(url);
            } catch (error) {
                alert('コピーに失敗しました。手動にてコピーしてください。');
                console.error(error);
            }
        },
    },
    computed: {
        lineAccountUrl() {
            const baseUrl = '/users/line_accounts/new';
            const lineMethod = this.formData.cv_method;

            if ([LINE_MEASURMENT.MESSAGING_API, LINE_MEASURMENT.LOGIN].includes(lineMethod)) {
            return `${baseUrl}?line_method=${encodeURIComponent(lineMethod)}`;
            } else {
            return baseUrl;
            }
        },
        isPageViewSelected() {
            return this.formData.method === CV_METHOD.PAGE_VIEW;
        },
        isExternalserviceSelected() {
            return this.formData.method === CV_METHOD.LINKE_TO_EXTERNAL_SERVICE;
        },
        isExternalServiceGroupSelected() {
            return this.isExternalserviceSelected && this.externalServiceGroup !== ''
        },
        currentServiceDetails() {
            if (this.externalServiceGroup === EXTERNAL_SERVICE_GROUP.ACCESS_TRADE) {
                return this.atServiceDetails;
            } else if (this.externalServiceGroup === EXTERNAL_SERVICE_GROUP.LINE) {
                return this.lineServiceDetails;
            }
            return [];
        },
        filterServiceDetails() {
            return this.currentServiceDetails.filter(details => {
                if (details.onlyTestUser && !this.is_test_user) {
                    return false;
                }
                if (details.requiresAccessTradeAdvertiserFlag && !this.access_trade_advertiser_cv_flag) {
                    return false;
                }
                return true;
            });
        },
        currentMeasuments() {
            if ([EXTERNAL_SERVICE_TYPE.LINE, EXTERNAL_SERVICE_TYPE.LINE_LINK_TO_ACCESS_TRADE].includes(this.formData.external_service_type)) {
                return this.lineMeasurments;
            } else if ([EXTERNAL_SERVICE_TYPE.LSTEP, EXTERNAL_SERVICE_TYPE.LSTEP_LINK_TO_ACCESS_TRADE].includes(this.formData.external_service_type)) {
                return this.lstepMeasurments;
            }
            return [];
        }
    },
    watch: {
        'formData.method'(newVal) {
            if (newVal === CV_METHOD.PAGE_VIEW) {
                this.formData.external_service_type = EXTERNAL_SERVICE_TYPE.NORMAL;
                this.externalServiceGroup = '';
                this.formData.cv_method = '';
                this.line = null;
            }
            if (newVal === CV_METHOD.LINKE_TO_EXTERNAL_SERVICE && !this.upper_master) {
                this.formData.method = '';
                this.externalServiceGroup = '';
                this.formData.external_service_type = EXTERNAL_SERVICE_TYPE.NORMAL;
                this.formData.cv_method = '';
                this.line = null;
                this.showUpgradeModal = true;
                this.$nextTick(() => {
                    const methodRadios = document.querySelectorAll('input[type="radio"][id^="method_"]');
                    methodRadios.forEach(radio => {
                        radio.checked = false;
                    });
                    const serviceGroupRadios = document.querySelectorAll('input[type="radio"][id^="externalServiceGroup_"]');
                    serviceGroupRadios.forEach(radio => {
                        radio.checked = false;
                    });
                });
            }
        }
    },
}
</script>
